export const ENV = window.location.hostname.includes('stage.')
  ? 'stage'
  : window.location.hostname.includes('my-test-app-9dt.pages.dev')
    ? 'prod'
    : window.location.port === '4173'
      ? 'test'
      : 'dev';

export const getServerUrl = () => {
  switch (ENV) {
    case 'stage':
      return 'stage.my-test-app-9dt.pages.dev';
    case 'prod':
      return 'my-test-app-9dt.pages.dev';
    case 'test':
      return 'http://localhost:8788';
    case 'dev':
    default:
      return 'http://localhost:8787';
  }
};
